// @ts-nocheck

import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import useRouter from '../../../../hooks/useRouter';
import { __ } from '../../../../i18n/l10n';
import Primary from '../buttons/Primary';
import Secondary from '../buttons/Secondary';

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0.6em;
`;

const commonButton = css`
  && {
    display: inline-block;
    width: 100%;
    font-size: 0.9em;
  }
`;

const StyledPrimary = styled(Primary)`
  ${commonButton}
`;

const StyledSecondary = styled(Secondary)`
  min-height: 3em;
  ${commonButton}
  && {
    text-transform: uppercase;
  }
`;

const MiddleWidth = styled.div`
  min-width: 50%;
`;

const StyledLink = styled(Link)`
  margin: 0 0.4em;
  min-width: 50%;
`;

type GridsPublicCtaProps = {
  className?: string;
  gridReference: string;
  toggleDetails?: () => void;
  isDetailsOpened?: boolean;
  isProgressBarFilled?: boolean;
};

const GridsPublicCta = ({
  className,
  gridReference,
  toggleDetails = () => {},
  isDetailsOpened = false,
  isProgressBarFilled = false,
}: GridsPublicCtaProps) => {
  const { location } = useRouter();
  const isCartOpened = useMemo(() => location.hash.indexOf('#cart') === 0, [location.hash]);
  const isDetailsMobileOpened = useMemo(() => location.hash.indexOf('#details') === 0, [location.hash]);
  return (
    <Wrap className={className}>
      {Target.__MOBILE__ ? (
        <>
          {!isDetailsMobileOpened ? (
            <StyledLink to={{ hash: '#details', state: { gridReference } }}>
              <StyledSecondary>{__('See details')}</StyledSecondary>
            </StyledLink>
          ) : null}
        </>
      ) : (
        <StyledSecondary onClick={toggleDetails}>
          {isDetailsOpened ? __('Close details') : __('See details')}
        </StyledSecondary>
      )}
      {isCartOpened ? (
        <MiddleWidth>
          <StyledPrimary $isDisabled>{__('Take part')}</StyledPrimary>
        </MiddleWidth>
      ) : (
        <StyledLink to={{ hash: '#cart', state: { gridReference } }}>
          <StyledPrimary $isDisabled={isProgressBarFilled}>{__('Take part')}</StyledPrimary>
        </StyledLink>
      )}
    </Wrap>
  );
};

export default GridsPublicCta;
